import { ReactElement } from 'react';
import LazyLoadedImage from '../../../../../../common/lazy-loaded-image/lazy-loaded-image';
import MaterialLink from '../../../../../../common/material-link/material-link';
import MaterialClickHandler from '../../../../../../common/material-click-handler/material-click-handler';
import PagesInfo from '../../../../../../common/pages-info/pages-info';
import { CatalogProps } from '../../../../../../utils/enhanced-ecommerce';
import imagePathCreator from '../../../../../../utils/image-path-creator/image-path-creator';
import isInteractiveStandaloneMaterial from '../../../../../../utils/interactive/is-interactive-standalone-material';
import previewHeightCalculator, { BlockType } from '../../../../../../utils/preview/preview-height-calculator';
import './material-image.scss';

type MaterialImageProps = {
    item: Material;
    onClick: VoidFunction;
    imageSize: BlockType;
    index?: number;
    internalPath?: string;
};

const MaterialImage = (props: MaterialImageProps): ReactElement => {
    const { item, onClick, imageSize, index, internalPath } = props;

    const isStandalone = isInteractiveStandaloneMaterial(item);
    const { width, height } = previewHeightCalculator(imageSize);

    const imageSource = item.firstPreviewImage?.plain;
    const imageProcessed = imagePathCreator.optimizedImg({ preview: imageSource }, { w: width, h: height, q: 50 });

    const materialProps: CatalogProps = { internalPath, itemIndex: index };

    return (
        <MaterialClickHandler transparent item={item} materialProps={materialProps}>
            <MaterialLink
                omitForBots
                className='material-image-wrapper'
                item={item}
                internalPath={internalPath}
                title={item.title}
                onClick={onClick}
                style={{ width, height }}
            >
                <LazyLoadedImage src={imageProcessed} alt={item.title} className='material-image' />
                {!isStandalone && <PagesInfo item={item} />}
            </MaterialLink>
        </MaterialClickHandler>
    );
};

export default MaterialImage;
